"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const PersonPreview = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)("img", { src: props.avatar, alt: "avatar" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { "data-cy": props["name-data-cy"], children: props.name }, void 0)] }, void 0));
};
exports.PersonPreview = PersonPreview;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  padding: ${({ theme }) => theme.spacings.m};

  img {
    background-color: ${({ theme }) => theme.colors.silverBase};
    border-radius: 50%;
    height: 2.25rem;
    margin-right: ${({ theme }) => theme.spacings.m};
    object-fit: cover;
    width: 2.25rem;
    &:not([src]) {
      visibility: hidden;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=index.js.map